// Overall theme scripts go into here
(function ($) {

	// Trigger a resize action
	setTimeout(function () { $(window).trigger('resize'); }, 200);

}(jQuery));